export default {
  middle: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/middle_part.svg?v=1649417899',
  right: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/right_part.svg?v=1649407200',
  left: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/left_part.svg?v=1649407201',
  selected: {
    middle: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/Middle_part_selected.svg?v=1649422191',
    right: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/Right_part_selected.svg?v=1649422191',
    left: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/left_part_style_selected.svg?v=1649422191',
  },
}
